import React from 'react';
import { EnvironmentUrls } from 'Roblox';
import { useTranslation } from 'react-utilities';
import makeTranslateWithLink from '../../utils/makeTranslateWithLink';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';

/**
 * Chargeback reactivate related notice. Has 2 versions for u18 and o18
 */
const ChargebackReactivateNoticePageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { websiteUrl } = EnvironmentUrls;
  const homePageUrl = `${websiteUrl}/`;
  const { translate } = useTranslation();
  const { punishmentData } = props;
  const translateWithLink = makeTranslateWithLink(translate);

  let displayContent: React.ReactNode = null;
  switch (punishmentData.verificationCategory) {
    case 'Email':
      displayContent = translateWithLink('Label.EmailReactivationNotice', homePageUrl);
      break;
    case 'VPC':
      displayContent = translateWithLink('Label.ParentReactivationNotice', homePageUrl);
      break;
    default:
      break;
  }

  return <div data-testid='chargeback-reactivate-notice'>{displayContent}</div>;
};

const ChargebackReactivateNoticePageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    return !!punishmentData.verificationCategory;
  },
  renderComponent: ChargebackReactivateNoticePageItem,
  configName: 'chargeback-reactivate-notice'
};

export default ChargebackReactivateNoticePageItemConfig;
